import { render, staticRenderFns } from "./DateFormatter.vue?vue&type=template&id=645c5b1b"
import script from "./DateFormatter.vue?vue&type=script&lang=js"
export * from "./DateFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports